









































import { Component, Vue, Prop } from 'vue-property-decorator';

/**
 * 配置项目头部
 */
const LEGEND_CONFIG = {
  head: {
    code: 'bsk',
    mountId: 'axxNewHeader',
  },
  secondNav: {
    isShow: false,
  },
  banner: {
    isShow: true,
    mountId: 'axxBBanner',
    system: 'beike',
  },
  sideBar: {
    isShow: false,
    mountId: 'axxBSideBar',
  },
  footer: {
    isShow: true,
    mountId: 'axxBFooter',
  },
};

(function legendStart() {
  const { loadLegendMinJs } = window;
  // const legend = new Legend(LEGEND_CONFIG);
  // legend.trigger('start');
  new Promise((resolve) => {
    loadLegendMinJs(() => {
      resolve(new window.Legend(LEGEND_CONFIG));
    });
  }).then((legend: any) => {
    legend.trigger('start');
  });
}());

@Component
export default class TheContainer extends Vue {
  // 是否显示公共头
  @Prop({ default: true }) readonly showHeader!: boolean;

  // 是否显示banner
  @Prop({ default: true }) readonly showBanner!: boolean;

  // 是否显示footer
  @Prop({ default: true }) readonly showFooter!: boolean;

  // app宽度 默认1180px
  @Prop({ default: '1180px' }) readonly width!: string;
}
